export default function debounce(callback, wait = 300) {
    let time;
    return (...args) => {
        clearTimeout(time);
        time = setTimeout(() => callback(...args), wait);
    };
}